import { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const useESgnatureFunctions = () => {
  const history = useHistory();
  const [requests, setRequests] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [showCreate, setShowCreate] = useState(false);

  const fetchRequests = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = statusFilter ? `?status=${statusFilter}` : '';
      const res = await axios.get(`${BASE_URL}/signatures${params}`, { withCredentials: true });
      setRequests(res.data?.data || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load signature requests');
    } finally {
      setLoading(false);
    }
  }, [statusFilter]);

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  const handleCreated = newReq => {
    setShowCreate(false);
    setRequests(prev => [newReq, ...(prev || [])]);
  };

  return { history, requests, setRequests, loading, setLoading, error, setError, statusFilter, setStatusFilter, showCreate, setShowCreate, fetchRequests, handleCreated };
};

export default useESgnatureFunctions;
